Librarian.Modules.RecentGroupsLinks = new Class({
    Extends: Librarian.Modules.Module,
    Binds: ["viewAll", "getCustomData", "clickHandler"],

    options: {
        classPrefix: "modules-recentgroupslinks-",
        label: null,
        importDate: null,
        viewOption: null,
        excludeCategory: null,
        catType: Librarian.catType.globalFavorite,
        maxResults: 7,
        action: "preview" // "download", or "preview"
    },

    initialize: function(options, wrapperEl) {
        this.setOptions(options);
        this.parent(this.options, wrapperEl);
    },

    load: function() {
        var self = this;

        if (!this.wrapperEl) {
            return;
        }

        this.parent();

        if (!this.containerEl) {
            return;
        }

        if (this.options.isSquare) {
            // add view all button
            new Element("span", {
                "class": "viewAll",
                events: {
                    click: this.viewAll
                },
                text: Librarian.Lang.getString("homepage_viewall"),
                "data-translation": "homepage_viewall"
            }).injectInside(this.wrapperEl);
        }

        var layout = function (response) {
            var data = response;
            if (response && response.data)
                data = response.data;
            if (response && response.groups)
                data = response.groups;
            data.forEach(function(file) {
                var linkEl = new Element("div",
                    {
                        "class": "file-link",
                        events: {
                            click: function(event) {
                                self.clickHandler(event, file);
                            }
                        }
                    }).injectInside(self.containerEl);

                new Element("img",
                    {
                        "class": "file-link-icon",
                        src: Librarian.Utils.getContentTypeIcon(file)
                    }).injectInside(linkEl);

                new Element("span",
                    {
                        "class": "file-link-text",
                        text: file.name,
                        title: file.name
                    }).injectInside(linkEl);

                if (self.options.importDate == "true") {
                    linkEl.addClass("date");

                    new Element("div",
                        {
                            "class": "file-link-date",
                            text: Librarian.Utils.extractDateFromString(file.importdate).format("%m/%d/%y")
                        }).injectInside(linkEl);
                }
            });
        };

        //Get groups from only root cat if root files filter added
        if (this.options.rootfiles && this.options.rootfiles == "true") {
            new Librarian.Request.JSON({
                url: Librarian.path.getMethodUrl("getcg") + "&out=cjson&cid=" + Librarian.specialCategories.GlobalFavorites.CatId + "&vname=SearchGroups",
                onSuccess: function(json) {
                    return layout(json);
                }
            }).send();
        } else {
            Librarian.Utils.getNewestGroups(this.options.maxResults, function (response) {
                return layout(response);
            }, null, null, null, true, self.getCustomData);
        }
    },

    clickHandler: function(event, file) {
        event.stopPropagation();

        if (this.options.action === "preview") {
            Librarian.PreviewWindow.openPreviewWindow(file);
        }

        else if (this.options.action === "open") {
            var url = '#';

            // Build the url from the data we have
            if (file.fileid > 0)
                url += "fileid=" + file.fileid;
            else if (file.groupid > 0)
                url += "groupid=" + file.groupid;

            // Including the cat ID if we have it
            if (file.extrafields && file.extrafields.CatID != null)
                url += "&catid=" + file.extrafields.CatID;
            else if (file.catid > 0)
                url += "&catid=" + file.catid;

            // And set that as the url for this link
            document.location.href = url + "&type=" + this.options.catType;
        }
    },

    viewAll: function(event) {
        var self = this;

        if (this.options.rootfiles && this.options.rootfiles == "true") {
            var hash = "catid=" + Librarian.specialCategories.GlobalFavorites.CatId + "&type=" + Librarian.catType.globalFavorite;
            Librarian.Utils.changeHash(hash);
            Librarian.Utils.onHashChange(hash, true);
        } else {
            Librarian.Utils.getNewestGroups(20, function (response) {

                Librarian.Homepage.hide();
                if (Librarian.features.mountedVuePages.load)
                    Librarian.Modules.MountedVuePage.hide();

                if (self.options.viewOption) {
                    Librarian.ListView.prepTreeGrid(1, 0);
                    fileList.setData(response);
                } else
                    tileList.loadFromArray(response.data);

                var itemEl = $("pageheader");
                if (itemEl) {
                    itemEl.show();
                }

                if (Librarian.pageheader != null) {
                    Librarian.pageHeader.destroy();
                    Librarian.pageHeader = null;
                }

                $('myInProgress').empty();

                Librarian.pageHeader = new Librarian.PageHeader({
                    name: "Newest Groups",
                    showHeaderMenu: false
                });

            }, null, null, null, true, self.getCustomData);
        }
    },

    getCustomData: function (data, url) {
        var resultOptions = {
            data: {},
            url: url
        };

        if ((typeof Library.getSendData == "function")) {
            var sendData = Library.getSendData(data, url);

            if (sendData != null) {
                resultOptions = sendData;
            }
        }
       
        if (this.options.excludeCategory != null) {
            if (!resultOptions.url.contains("in=ujson")) {
                resultOptions.url += "&in=ujson";
            }

            resultOptions.data.ExcludeFields = {
                "FilePath": this.options.excludeCategory
            }
        }

        return resultOptions;
    }

});